// api
import createNewQuoteAPICall from './api/createNewQuote';
import acceptQuoteAPICall from './api/acceptQuote';
import rejectQuoteAPICall from './api/rejectQuote';
import getQuoteDetailAPICall from './api/getQuoteDetail';
import updateQuoteDetailApiCall from './api/updateQuoteDetail';
// settings
import quoteFormDefaultValues from './components/quoteForm/config/quoteFormDefaultValues';
import moment from 'moment';
import { STATES } from './constants';

//
//
//
//
//
//
// defaultValues
//
//
//
//
//
//
//

const getDefaultInitialFormValues = () => deepCopy(quoteFormDefaultValues);

const defaultValues = {
  getDefaultInitialFormValues,
};

//
//
//
//
//
//
// utils
//
//
//
//
//
//
//

const deepCopy = (object) => JSON.parse(JSON.stringify(object));

const navigateToList = async ({ history }) => {
  history.push('/emergencies/');
};

const utils = {
  deepCopy,
  navigateToList,
};

//
//
//
//
//
//
// business
//
//
//
//
//
//
//

const canQuoteBeEdited = (ticket) => {
  if (!!!ticket) return false;
  return true;
};
const canQuoteStateBeUpdated = (ticket) => {
  if (!!!ticket) return false;
  const state = ticket.synthetic_state;
  const statesThatCanEdit = ['QUOTE_SENT'];
  return statesThatCanEdit.includes(state);
};
const canQuoteBeEditedAfterAcceptance = (ticket) => {
  if (!!!ticket) return false;
  const state = ticket.synthetic_state;
  const statesThatCanEdit = [STATES.ACCEPTED, STATES.DONE];
  return statesThatCanEdit.includes(state);
};

function getPriceChanges(originalQuote, newValues) {
  const originalPrice = originalQuote.price;
  const newPrice = newValues.price;

  if (originalPrice.amount !== newPrice.amount || originalPrice.currency !== newPrice.currency) {
    return {
      price: {
        previous: originalPrice,
        current: newPrice,
      },
    };
  }

  return {};
}

function getCostChanges(originalQuote, newValues) {
  const originalCost = originalQuote.operation_details.cost;
  originalCost.amount = `${originalCost.amount}`;
  const newCost = newValues.operation_details.cost;
  newCost.amount = `${newCost.amount}`;

  if (originalCost.amount !== newCost.amount || originalCost.currency !== newCost.currency) {
    return {
      cost: {
        previous: originalCost,
        current: newCost,
      },
    };
  }

  return {};
}

function getQuoteChangesAfterEditing(originalQuote, newValues) {
  const priceChanges = getPriceChanges(originalQuote, newValues);
  const costChanges = getCostChanges(originalQuote, newValues);

  return {
    ...priceChanges,
    ...costChanges,
  };
}

function getCarrierChanges(originalQuote, newValues) {
  const originalCarrier = originalQuote.operation_details.carrier;
  const newCarrier = newValues.operation_details.carrier;
  if (originalCarrier !== newCarrier)
    return {
      carrier: {
        previous: originalCarrier,
        current: newCarrier,
      },
    };
  return {};
}

function getDetailsChanges(originalQuote, newValues) {
  const originalDetails = originalQuote.operation_details.details;
  const newDetails = newValues.operation_details.details;
  if (originalDetails !== newDetails)
    return {
      details: {
        previous: originalDetails,
        current: newDetails,
      },
    };
  return {};
}

function getQuoteChangesThatDontTriggerModalAfterAcceptance(originalQuote, newValues) {
  const carrierChanges = getCarrierChanges(originalQuote, newValues);
  const detailsChanges = getDetailsChanges(originalQuote, newValues);

  return {
    ...carrierChanges,
    ...detailsChanges,
  };
}

const bussiness = {
  canQuoteBeEdited,
  canQuoteStateBeUpdated,
  canQuoteBeEditedAfterAcceptance,
  getQuoteChangesAfterEditing,
  getQuoteChangesThatDontTriggerModalAfterAcceptance,
};

//
//
//
//
//
//
// data transformation
//
//
//
//
//
//
//

const cleanTimeFromBackend = (time) => {
  if (time.length === 8) {
    time = time.slice(0, 5);
  }
  return time;
};

const cleanNumberForBackend = (numberInStringFormat) => {
  if (!numberInStringFormat) return 0;
  if (numberInStringFormat === '') return 0;
  return parseFloat(numberInStringFormat) || 0;
};

const prepareTimeForBackend = (time) => {
  if (time.length === 5) return `${time}:00`;
  return time;
};

const getDatetimeFromSeparateDateAndTime = ({ date, time }) => {
  if (time === '' || date === '') return '';
  const timeParts = time.split(':');
  const hours = timeParts[0];
  const minutes = timeParts[1];
  const dateTime = moment(date).hours(hours).minutes(minutes);
  const dateTimeInIsoFormat = dateTime.toISOString();
  return dateTimeInIsoFormat;
};

const getSeparateDateAndTimeFromDatetime = ({ dateTime }) => {
  if (!dateTime || dateTime === '')
    return {
      date: '',
      time: '',
    };
  const dateTimeMoment = moment(dateTime).local();
  const date = dateTimeMoment.format('YYYY-MM-DD');
  const time = dateTimeMoment.format('HH:mm');
  return {
    date,
    time,
  };
};

const getInitialNewQuoteFormValuesFromTicketDetail = ({ ticketDto }) => {
  let initialValues = getDefaultInitialFormValues();

  const copyTicketDto = deepCopy(ticketDto);

  // pickup
  initialValues.order_data.pickup = {};
  initialValues.order_data.pickup.date = copyTicketDto.order_data.pickup.date;
  initialValues.order_data.pickup.time_from = cleanTimeFromBackend(
    copyTicketDto.order_data.pickup.time_from
  );
  initialValues.order_data.pickup.time_to = cleanTimeFromBackend(
    copyTicketDto.order_data.pickup.time_to
  );
  //  dropoff
  initialValues.order_data.dropoff = {};
  initialValues.order_data.dropoff.date = copyTicketDto.order_data.dropoff.date;
  initialValues.order_data.dropoff.time_from = cleanTimeFromBackend(
    copyTicketDto.order_data.dropoff.time_from
  );
  initialValues.order_data.dropoff.time_to = cleanTimeFromBackend(
    copyTicketDto.order_data.dropoff.time_to
  );

  return initialValues;
};

const getInitialQuoteDetailFormValuesFromTicketDetailAndQuoteDetail = ({ ticketDto, quoteDto }) => {
  let initialValues = getDefaultInitialFormValues();

  const copyQuoteDto = deepCopy(quoteDto);

  // pickup
  initialValues.order_data.pickup = {};
  initialValues.order_data.pickup.date = copyQuoteDto.order_data.pickup.date;
  initialValues.order_data.pickup.time_from = cleanTimeFromBackend(
    copyQuoteDto.order_data.pickup.time_from
  );
  initialValues.order_data.pickup.time_to = cleanTimeFromBackend(
    copyQuoteDto.order_data.pickup.time_to
  );
  //  dropoff
  initialValues.order_data.dropoff = {};
  initialValues.order_data.dropoff.date = copyQuoteDto.order_data.dropoff.date;
  initialValues.order_data.dropoff.time_from = cleanTimeFromBackend(
    copyQuoteDto.order_data.dropoff.time_from
  );
  initialValues.order_data.dropoff.time_to = cleanTimeFromBackend(
    copyQuoteDto.order_data.dropoff.time_to
  );
  //   prices
  initialValues.price = copyQuoteDto.price;
  //   operation details
  initialValues.operation_details.cost = {
    amount: cleanNumberForBackend(copyQuoteDto.operation_details.cost.amount),
    currency: copyQuoteDto.operation_details.cost.currency,
  };
  initialValues.operation_details.carrier = copyQuoteDto.operation_details.carrier;
  initialValues.operation_details.details = copyQuoteDto.operation_details.details;
  //quote_costs
  initialValues.quote_costs =
    !copyQuoteDto.quote_costs?.length > 0
      ? null
      : copyQuoteDto.quote_costs.map((quote) => ({
          carrier: {
            id: quote.carrier.id,
            name: quote.carrier.name,
          },
          cost: {
            amount: cleanNumberForBackend(quote.cost.amount),
            currency: quote.cost.currency,
          },
          comments: quote.comments,
          carrier_id: quote.carrier.id,
        }));
  // expiration date
  const expires_at = copyQuoteDto.expires_at;
  const separatedExpiresAt = getSeparateDateAndTimeFromDatetime({ dateTime: expires_at });
  initialValues.expiration_date = separatedExpiresAt.date;
  initialValues.expiration_time = separatedExpiresAt.time;

  initialValues.conditions = copyQuoteDto.conditions;

  return initialValues;
};

const getQuoteDtoFromFormValuesAndTicket = ({ values, ticketDto, isQuoteCostActive }) => {
  const copyTicketDto = deepCopy(ticketDto);
  const dto = {
    order_data: {
      pickup: copyTicketDto.order_data.pickup,
      dropoff: copyTicketDto.order_data.dropoff,
      service_type: copyTicketDto.order_data.service_type,
      loads_data: copyTicketDto.order_data.loads_data,
    },
  };

  // proposed date and times
  dto.order_data.pickup.date = values.order_data.pickup.date;
  dto.order_data.pickup.time_from = prepareTimeForBackend(values.order_data.pickup.time_from);
  dto.order_data.pickup.time_to = prepareTimeForBackend(values.order_data.pickup.time_to);
  dto.order_data.dropoff.date = values.order_data.dropoff.date;
  dto.order_data.dropoff.time_from = prepareTimeForBackend(values.order_data.dropoff.time_from);
  dto.order_data.dropoff.time_to = prepareTimeForBackend(values.order_data.dropoff.time_to);

  //   price
  dto.price = {
    amount: values.price.amount,
    currency: values.price.currency,
  };

  dto.suggested_price = {
    amount: values.suggested_price.amount,
    currency: values.suggested_price.currency,
  };

  dto.price_suggestion_id = values.price_suggestion_id;

  dto.operation_details = {
    carrier: values.operation_details.carrier,
    cost: {
      amount: cleanNumberForBackend(values.operation_details.cost.amount),
      currency: values.operation_details.cost.currency,
    },
    details: values.operation_details.details,
  };
  // quote_costs
  dto.quote_costs =
    !copyTicketDto.cargo || !isQuoteCostActive || !values.quote_costs?.length > 0
      ? null
      : values.quote_costs.map((quote, i) => ({
          route_id: copyTicketDto.cargo.routes[i].id,
          carrier: {
            id: quote.carrier.id,
            name: quote.carrier.name,
          },
          cost: {
            amount: cleanNumberForBackend(quote.cost.amount),
            currency: quote.cost.currency,
          },
          bid_id: quote.bid_id,
          comments: quote.comments,
          carrier_id: quote.carrier.id,
        }));

  //  expires at
  const expiresAtDate = values.expiration_date;
  const expiresAtTime = values.expiration_time;
  const expires_at = getDatetimeFromSeparateDateAndTime({
    date: expiresAtDate,
    time: expiresAtTime,
  });
  if (expires_at !== '' && expires_at !== null) dto.expires_at = expires_at;

  dto.conditions = values.conditions;

  return dto;
};

const getPriceSuggestionDTO = ({ ticketDetail, values }) => {
  const input = {
    shipper_data: { ...ticketDetail.shipper_data },
    order_data: { ...ticketDetail.order_data },
    currency: values.price.currency,
  };
  input.order_data.pickup = {
    ...input.order_data.pickup,
    ...values.order_data.pickup,
  };
  input.order_data.dropoff = {
    ...input.order_data.dropoff,
    ...values.order_data.dropoff,
  };
  const dto = { input };
  if (input.order_data.pickup.date === '' || input.order_data.dropoff.date === '') return null;
  return dto;
};

const getUpdateQuoteDetailDto = ({ originalQuote, newValues }) => {
  const updateQuoteDetailDto = {
    operation_details: {
      cost: {
        // this is what we will send to backend
        amount: quoteService.dataTransformation.cleanNumberForBackend(
          newValues.operation_details.cost.amount
        ),
        currency: originalQuote.operation_details.cost.currency,
      },
      carrier: newValues.operation_details.carrier,
      details: newValues.operation_details.details,
    },
    quote_costs:
      originalQuote.quote_costs.length === 0
        ? null
        : newValues.quote_costs.map((quote, i) => ({
            route_id: originalQuote.quote_costs[i].route?.id,
            carrier: {
              id: quote.carrier.id,
              name: quote.carrier.name,
            },
            cost: {
              amount: cleanNumberForBackend(quote.cost.amount),
              currency: quote.cost.currency,
            },
            bid_id: quote.bid_id,
            comments: quote.comments,
            carrier_id: quote.carrier.id,
          })),
  };
  if (originalQuote.price.amount !== newValues.price.amount) {
    updateQuoteDetailDto.price = originalQuote.price;
    updateQuoteDetailDto.price.amount = newValues.price.amount;
  }
  if (originalQuote.price.currency !== newValues.price.currency) {
    if (updateQuoteDetailDto.price === undefined) {
      updateQuoteDetailDto.price = originalQuote.price;
    }
    updateQuoteDetailDto.price.currency = newValues.price.currency;
  }
  if (updateQuoteDetailDto.price !== undefined) {
    delete updateQuoteDetailDto.price.formatted;
  }
  return updateQuoteDetailDto;
};

const dataTransformation = {
  getInitialNewQuoteFormValuesFromTicketDetail,
  getInitialQuoteDetailFormValuesFromTicketDetailAndQuoteDetail,
  getQuoteDtoFromFormValuesAndTicket,
  getUpdateQuoteDetailDto,
  getPriceSuggestionDTO,
  cleanNumberForBackend,
};

//
//
//
//
//
//
// callBackend
//
//
//
//
//
//
//

// calls api to create a new Quote
const crateNewQuote = async ({ quoteDto, ticketId }) => {
  return createNewQuoteAPICall({ quoteDto, ticketId });
};

// calls api to accept a Quote
const acceptQuote = async ({ quoteId, ticketId }) => {
  return acceptQuoteAPICall({ quoteId, ticketId });
};

// calls api to reject a Quote
const rejectQuote = async ({ quoteId, ticketId, feedBackDTO }) => {
  return rejectQuoteAPICall({ quoteId, ticketId, feedBackDTO });
};

// calls api to get a QuoteDetail
const getQuoteDetail = async ({ quoteId, ticketId }) => {
  return getQuoteDetailAPICall({ quoteId, ticketId });
};

// calls api to update QuoteDetail
const updateQuoteDetail = async ({ ticketId, quoteId, updateQuoteDetailDto }) => {
  return updateQuoteDetailApiCall({ ticketId, quoteId, updateQuoteDetailDto });
};

const callBackend = { crateNewQuote, acceptQuote, rejectQuote, getQuoteDetail, updateQuoteDetail };

//
//
//
//
//
//
// quoteService
//
//
//
//
//
//
//

const quoteService = {
  defaultValues,
  utils,
  bussiness,
  dataTransformation,
  callBackend,
};

export default quoteService;
